import serviceInterceptor from '../../services/ServiceInterceptor';

export const getRebatesOverviewAPI = () =>
  serviceInterceptor.get(`/rebates/overview`);
